// Formateo de fechas para toda la app: "07/feb/2025" (día/mes-abrev/año, minúscula).
const MONTHS_ABBR = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

// Formatea a "07/feb/2025". Acepta "YYYY-MM-DD", ISO datetime o Date. "—" si vacío.
export function formatDate(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  let y, m, d;
  if (value instanceof Date) {
    if (isNaN(value)) return fallback;
    y = value.getFullYear(); m = value.getMonth(); d = value.getDate();
  } else {
    const s = String(value).trim();
    const iso = s.slice(0, 10);
    const parts = iso.split("-");
    if (parts.length === 3 && parts[0].length === 4) {
      // Fecha en formato ISO date: parseo manual para evitar corrimiento por zona horaria
      y = parseInt(parts[0], 10);
      m = parseInt(parts[1], 10) - 1;
      d = parseInt(parts[2], 10);
    } else {
      const dt = new Date(s);
      if (isNaN(dt)) return fallback;
      y = dt.getFullYear(); m = dt.getMonth(); d = dt.getDate();
    }
  }
  if (isNaN(y) || isNaN(m) || isNaN(d) || m < 0 || m > 11) return fallback;
  return `${String(d).padStart(2, "0")}/${MONTHS_ABBR[m]}/${y}`;
}

// Con hora: "07/feb/2025 14:30".
export function formatDateTime(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  const dt = value instanceof Date ? value : new Date(value);
  if (isNaN(dt)) return fallback;
  const base = formatDate(dt, fallback);
  if (base === fallback) return fallback;
  return `${base} ${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
}
